import 'core-js/es/symbol';
import 'core-js/es/array';
import 'core-js/es/promise';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import externalLinks from './components/external-links';
import maps from './components/map';
import locationMap from './components/location-map';
import hlsPlayer from './components/hls-player';
import popup from './components/popup';

// Require components
require('./components/hero');
require('./components/header');
require('./components/slider');
require('./components/gallery');
require('./components/faqs');
require('./components/transition');
require('./components/entity');

document.addEventListener('DOMContentLoaded', () => {
	externalLinks.init();
	maps.init();
	locationMap.init();
	hlsPlayer.init();
	popup.init();
});

